import logoImg from '../assets/images/logo.png';
import heroImg from '../assets/images/hero.jpg';
import heroSmall1Img from '../assets/images/hero-small-1.jpg';
import heroSmall2Img from '../assets/images/hero-small-2.jpg';
import about1Img from '../assets/images/about-1.jpg';
import about2Img from '../assets/images/about-2.jpg';

import galleryBlocks from '../assets/images/gallery-block-building.jpg';
import galleryArt from '../assets/images/gallery-art-time.jpg';
import galleryStory from '../assets/images/gallery-story-circle.jpg';
import galleryOutdoor from '../assets/images/gallery-outdoor-play.jpg';
import galleryMusic from '../assets/images/gallery-music-dance.jpg';
import gallerySnack from '../assets/images/gallery-snack-time.jpg';
import gallerySand from '../assets/images/gallery-sand-play.jpg';
import galleryCelebrations from '../assets/images/gallery-celebrations.jpg';

export const IMAGES = {
  logo: logoImg,
  hero: heroImg,
  heroSmall1: heroSmall1Img,
  heroSmall2: heroSmall2Img,
  about1: about1Img,
  about2: about2Img,
  gallery: [
    galleryBlocks,
    galleryArt,
    galleryStory,
    galleryOutdoor,
    galleryMusic,
    gallerySnack,
    gallerySand,
    galleryCelebrations,
  ],
};

export const SCHOOL = {
  name: "St Lord's",
  fullName: "St Lord's International Public School",
  tagline: 'A Bright Beginning for a Brighter Future',
  phone: '+91 8073 162 527',
  phoneRaw: '918073162527',
  timings: '9:00 AM to 2:00 PM',
  ages: '1.5 Years to 5 Years',
  address: '10th Main Rd, Keshava Nagar, Cottonpete, Bengaluru, Karnataka 560023',
  mapQuery: "St Lord's International Public School, 10th Main Rd, Keshava Nagar, Cottonpete, Bengaluru 560023",
};

export const NAV = [
  { label: 'Home', id: 'home' },
  { label: 'About', id: 'about' },
  { label: 'Programs', id: 'programs' },
  { label: 'Facilities', id: 'facilities' },
  { label: 'Day Plan', id: 'routine' },
  { label: 'Gallery', id: 'gallery' },
  { label: 'Admission', id: 'admission' },
  { label: 'Contact', id: 'contact' },
];

export const STATS = [
  { value: 500, suffix: '+', label: 'Happy Little Learners', color: '#FF4D97' },
  { value: 25, suffix: '+', label: 'Caring Teachers and Helpers', color: '#2D9CFF' },
  { value: 20, suffix: '+', label: 'Fun Activities Every Week', color: '#37B24D' },
  { value: 5, suffix: ' hrs', label: 'Of Joyful Learning Daily', color: '#FF8A3D' },
];

export const PILLARS = [
  { title: 'Play', text: 'Free and guided play builds imagination and motor skills.', color: '#FF4D97' },
  { title: 'Learn', text: 'Early learning through stories, rhymes, shapes and colours.', color: '#2D9CFF' },
  { title: 'Make Friends', text: 'Group activities teach sharing, kindness and teamwork.', color: '#37B24D' },
  { title: 'Build Confidence', text: 'Every child is encouraged to try, speak and shine.', color: '#FF8A3D' },
];

export const PROGRAMS = [
  {
    title: 'Day Care',
    age: '1.5 to 5 Years',
    icon: 'sun',
    color: '#FF4D97',
    text: 'A warm, safe and playful home away from home with meals, rest time and caring attention for the whole school day.',
    points: ['Open 9:00 AM to 2:00 PM', 'Healthy meals provided', 'Story and rest time'],
  },
  {
    title: 'Play Group',
    age: '1.5 to 2.5 Years',
    icon: 'heart',
    color: '#FF8A3D',
    text: 'Gentle first steps into school life through sensory play, music, rhymes and plenty of cuddles.',
    points: ['Sensory and water play', 'Rhymes and movement', 'Settling-in support'],
  },
  {
    title: 'Nursery',
    age: '2.5 to 3.5 Years',
    icon: 'palette',
    color: '#2D9CFF',
    text: 'Little explorers learn colours, shapes, sounds and numbers through art, craft and hands-on activities.',
    points: ['Art and craft', 'Colours, shapes and sounds', 'Language and speaking skills'],
  },
  {
    title: 'Pre-School Support',
    age: '3.5 to 5 Years',
    icon: 'book',
    color: '#37B24D',
    text: 'Gets children school-ready with early reading, writing, counting and social skills in a joyful way.',
    points: ['Pre-reading and pre-writing', 'Counting and number sense', 'School readiness'],
  },
];

export const FACILITIES = [
  { title: 'Indoor and Outdoor Activities', icon: 'palette', color: '#FF4D97', bg: '#FFE3F0', text: 'Art rooms, play zones, slides and open play areas to run, climb and explore.' },
  { title: 'Healthy Meals Provided', icon: 'meal', color: '#E8590C', bg: '#FFF3C4', text: 'Fresh, nutritious and child-friendly meals and snacks served on time every day.' },
  { title: 'Safe and Secure Campus', icon: 'shield', color: '#1C7ED6', bg: '#D9F0FF', text: 'A protected campus with careful supervision, safe furniture and child-safe spaces.' },
  { title: 'Personal Attention to Every Child', icon: 'group', color: '#D6336C', bg: '#FFE0E8', text: 'Small groups and loving caregivers who know each child by name and by nature.' },
  { title: 'Early Learning and Development', icon: 'bulb', color: '#2B8A3E', bg: '#DDF5DF', text: 'Activity-based learning that grows language, thinking, creativity and motor skills.' },
  { title: 'Play Group and Pre-School Support', icon: 'book', color: '#7048E8', bg: '#EBE3FF', text: 'Guided programs that prepare little ones step by step for formal school.' },
];

export const ROUTINE = [
  { time: '9:00 AM', title: 'Happy Welcome and Circle Time', text: 'Hellos, songs, weather talk and a warm start to the day.', color: '#FF4D97', icon: 'sun' },
  { time: '9:45 AM', title: 'Free Play and Sensory Fun', text: 'Blocks, toys, sand and water play to spark curiosity.', color: '#2D9CFF', icon: 'star' },
  { time: '10:30 AM', title: 'Healthy Snack Time', text: 'Fruits and snacks, with lots of practice in good eating habits.', color: '#37B24D', icon: 'meal' },
  { time: '11:00 AM', title: 'Art, Craft and Music', text: 'Painting, clay, dance, rhymes and creative time.', color: '#FF8A3D', icon: 'palette' },
  { time: '12:00 PM', title: 'Outdoor Play', text: 'Slides, games and fresh air in our safe play area.', color: '#8B5CF6', icon: 'heart' },
  { time: '12:45 PM', title: 'Lunch Time', text: 'A wholesome meal enjoyed together with friends.', color: '#E8590C', icon: 'meal' },
  { time: '1:15 PM', title: 'Story and Rest Time', text: 'Soft stories and quiet rest to recharge little batteries.', color: '#1C7ED6', icon: 'moon' },
  { time: '2:00 PM', title: 'Goodbye Song and Home Time', text: 'Smiles, hugs and a happy handover to parents.', color: '#D6336C', icon: 'heart' },
];

export const BUBBLES = [
  { label: 'Art and Craft', color: '#FF4D97' },
  { label: 'Music and Dance', color: '#8B5CF6' },
  { label: 'Story Time', color: '#2D9CFF' },
  { label: 'Sand and Water Play', color: '#FF8A3D' },
  { label: 'Blocks and Puzzles', color: '#37B24D' },
  { label: 'Rhymes and Songs', color: '#FFC83D' },
  { label: 'Outdoor Games', color: '#F03E3E' },
  { label: 'Nature Walk', color: '#20C997' },
];

export const GALLERY = [
  { label: 'Block building', color: '#FF4D97', tall: true },
  { label: 'Art time', color: '#2D9CFF' },
  { label: 'Story circle', color: '#37B24D' },
  { label: 'Outdoor play', color: '#FF8A3D', tall: true },
  { label: 'Music and dance', color: '#8B5CF6' },
  { label: 'Snack time', color: '#FFC83D' },
  { label: 'Sand play', color: '#20C997', tall: true },
  { label: 'Celebrations', color: '#F03E3E' },
];

export const TESTIMONIALS = [
  { name: 'Parent of a Play Group child', text: 'My daughter runs to the gate every morning. The teachers are patient and she has learned so many rhymes already.', color: '#FF4D97' },
  { name: 'Parent of a Nursery child', text: 'The campus feels safe and the meals are healthy. We love the daily updates and the personal attention.', color: '#2D9CFF' },
  { name: 'Parent of a Day Care child', text: 'As working parents, we needed a place we can trust. Our son is happy, confident and has made lovely friends.', color: '#37B24D' },
];

export const STEPS = [
  { title: 'Enquire', text: 'Call or WhatsApp us to share your child\'s age and your questions.', color: '#FF4D97' },
  { title: 'Visit', text: 'Come see our classrooms, play areas and meet our team.', color: '#2D9CFF' },
  { title: 'Register', text: 'Complete the simple admission form with the required documents.', color: '#37B24D' },
  { title: 'Join the Fun', text: 'Your child starts a happy first day with us.', color: '#FF8A3D' },
];

export const FAQS = [
  { q: 'What age group do you admit?', a: 'We welcome children from 1.5 years to 5 years across Day Care, Play Group, Nursery and Pre-School Support.' },
  { q: 'What are the school timings?', a: 'Our day runs from 9:00 AM to 2:00 PM.' },
  { q: 'Are meals provided?', a: 'Yes. Healthy meals and snacks are provided every day.' },
  { q: 'How do you keep children safe?', a: 'Our campus is safe and secure, with caring staff supervising children at all times.' },
  { q: 'How can I apply for admission?', a: 'Call or WhatsApp us on +91 8073 162 527, or fill the enquiry form on this page and we will get back to you.' },
];
